import "./instrument"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import * as ReactDOM from "react-dom/client"
import "./index.css"
import App from "./app/app"
import { AuthProvider } from "./app/auth-context"
import { LocaleProvider } from "./app/locale-context"
import { ThemeProvider } from "./app/theme-context"
import { UserProvider } from "./app/user-context"

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ThemeProvider>
				<LocaleProvider>
					<AuthProvider>
						<UserProvider>
							<App />
						</UserProvider>
					</AuthProvider>
				</LocaleProvider>
			</ThemeProvider>
		</QueryClientProvider>
	</StrictMode>,
)
